// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__3fTPj","loadingDivs":"layout_loadingDivs__27TTh","loadingAnimation":"layout_loadingAnimation__3lFSz","loadingSpinner":"layout_loadingSpinner__rYhu4"};